import { render } from "./Cache.vue?vue&type=template&id=7316b884"
import script from "./Cache.vue?vue&type=script&lang=js"
export * from "./Cache.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Cache.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7316b884"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7316b884', __exports__)) {
    api.reload('7316b884', __exports__)
  }
  
  module.hot.accept("./Cache.vue?vue&type=template&id=7316b884", () => {
    api.rerender('7316b884', render)
  })

}


export default __exports__